// extracted by mini-css-extract-plugin
export default {"hasBottomNav":"wJvlh"};